import { useEffect } from "react";

// Applies a subtle vertical parallax to any element with [data-parallax="<speed>"]
// The element should be slightly taller than its overflow-hidden wrapper.
export default function useParallax(dep) {
  useEffect(() => {
    const imgs = Array.from(document.querySelectorAll("[data-parallax]"));
    if (!imgs.length) return;

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    let raf = null;

    const update = () => {
      const vh = window.innerHeight;
      imgs.forEach((img) => {
        const wrap = img.parentElement;
        if (!wrap) return;
        const rect = wrap.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return; // offscreen skip
        const center = rect.top + rect.height / 2;
        const prog = (center - vh / 2) / (vh / 2 + rect.height / 2); // -1..1
        const speed = parseFloat(img.dataset.parallax) || 0.15;
        const move = -prog * rect.height * speed;
        img.style.transform = `translate3d(0, ${move.toFixed(1)}px, 0)`;
      });
      raf = null;
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    // run after layout settles
    const t = setTimeout(update, 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    return () => {
      clearTimeout(t);
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [dep]);
}
